export enum SOCIAL_MEDIA {
  FACEBOOK = 'facebook',
  TELEGRAM = 'telegram',
  WHATSAPP = 'whatsapp',
  INSTAGRAM = 'instagram',
  COPY_LINK = 'copy-link',
  X = 'x',
}
